import script from "./ThreeProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./ThreeProduct.vue?vue&type=script&setup=true&lang=js"

import "./ThreeProduct.vue?vue&type=style&index=0&id=82ae3ae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82ae3ae0"]])

export default __exports__